module.exports = __webpack_public_path__ + "static/media/chase-patrulha-pata@2x.35522bbf.png";